<template lang="pug">
v-container.py-10.d-flex.flex-column.align-center(v-if="content.link")
  grid-container.align-center(
    cols="auto",
    cols-md="500px 340px",
    gap-md="60px"
  )
    .page-home-featuredvideo-text
      .text-h4.font-weight-bold.primary--text(v-html="content.title")
      .text-body-1.font-weight-bold.mt-3(v-html="content.text")
      v-btn.font-weight-bold.text-capitalize.px-8(
        href="/novidades/videos",
        color="primary",
        depressed
      ) Mais vídeos
    v-img.page-home-featuredvideo-video-wrap.relative(
      src="/img/shape1.png",
      max-width="100%",
      contain
    )
      iframe.absolute.page-home-featuredvideo-video(
        :src="`https://www.youtube.com/embed/${getYoutubeCode(content.link)}`",
        frameborder="0",
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen>
      )
</template>

<script>
import { getYoutubeCode } from "@/components/utils.js";

const _config = {
  mod: "featuredVideo",
  path: "/web-canal",
};

export default {
  data: () => ({
    title: _config.title,
    path: _config.path,
  }),
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
  beforeCreate() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style>
.page-home-featuredvideo-video {
  top: 19%;
  left: 5%;
  width: 93%;
  height: 70%;
}
@media screen and (min-width: 960.001px) {
  .page-home-featuredvideo-text {
    grid-column-start: 2;
  }
  .page-home-featuredvideo-video-wrap {
    grid-row-start: 1;
  }
}
</style>
